import { render } from "./HcCard.vue?vue&type=template&id=2fad1137&scoped=true"
import script from "./HcCard.vue?vue&type=script&lang=js"
export * from "./HcCard.vue?vue&type=script&lang=js"

import "./HcCard.vue?vue&type=style&index=0&id=2fad1137&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fad1137"]])

export default __exports__